import { render, staticRenderFns } from "./voiceCardViewPro.vue?vue&type=template&id=62c05158&scoped=true"
import script from "./voiceCardViewPro.vue?vue&type=script&lang=js"
export * from "./voiceCardViewPro.vue?vue&type=script&lang=js"
import style0 from "./voiceCardViewPro.vue?vue&type=style&index=0&id=62c05158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c05158",
  null
  
)

export default component.exports